export default __webpack_public_path__ + "956c2a1e9cdc601fcda359670db8fead.svg";